import Aos from 'aos';
import { useEffect } from 'react';
import Image from '../../assests/man.png';
import './About.css';

const About = () => {
  useEffect(() => {
    Aos.init({
      duration: 2000,
      once: false,
    });

    // Add this line to refresh AOS on each re-render
    Aos.refresh();

    // Cleanup function
    return () => {
      Aos.refresh();
    };
  }, []);
  return (
    <section data-aos="fade-up" className="about container section" id="about">
      <h2 className="section__title">About Me</h2>

      <div className="section__container grid">
        <img src={Image} alt="" className="about__img" />

        <div className="about__data grid">
          <div className="about__info ">
            <p className="about__description">
              I am Abdulaziz Rustamov, Web Developer and Grafic Designer from
              Uzbekistan. I have rich experience in web site design and building
              and customization, also I am good at ReactJS.
            </p>
            <a href="/Resume.pdf" download className="btn">
              Download CV
            </a>
          </div>

          <div className="about__skills grid grid-cols-2 gap-5 max-sm:grid-cols-1">
            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">JavaScript</h3>
                <span className="skills__number ">Proficient</span>
              </div>
              <div className="skills__bar">
                <span className="skills__percentage bg-red-500"></span>
              </div>
            </div>
            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">TypeScript</h3>
                <span className="skills__number ">Proficient</span>
              </div>
              <div className="skills__bar">
                <span className="skills__percentage bg-purple-500"></span>
              </div>
            </div>

            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">ReactJs</h3>
                <span className="skills__number">Proficient</span>
              </div>
              <div className="skills__bar">
                <span className="skills__percentage bg-blue-500"></span>
              </div>
            </div>
            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">NextJs</h3>
                <span className="skills__number">Proficient</span>
              </div>
              <div className="skills__bar">
                <span className="skills__percentage bg-blue-900"></span>
              </div>
            </div>

            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">NodeJs</h3>
                <span className="skills__number">Proficient</span>
              </div>

              <div className="skills__bar">
                <span className="skills__percentage bg-yellow-500"></span>
              </div>
            </div>
            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">NestJs</h3>
                <span className="skills__number">Proficient</span>
              </div>

              <div className="skills__bar">
                <span className="skills__percentage bg-yellow-900"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <AboutBox/> */}
    </section>
  );
};

export default About;
